import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import Lightbox from "react-image-lightbox";
import moment from "moment";
//import filter modal
import {
    getRequest,
    postRequest,
    deleteRequest,
    putRequest,
    postRequestForm,
    deleteConfirmationWords,
    ImageFileUpload,
} from "components/Common/Utils";

import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";
import './cart.css'

import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Spinner,
    Badge,
    UncontrolledTooltip,
    Modal,
    Button,
} from "reactstrap";
import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { change } from "redux-form";
import { id } from "date-fns/locale";
import BuyProduct from "components/Modal/BuyProduct";
import kuliesLogo from 'assets/images/kulies_logo.png';
import * as htmlToImage from 'html-to-image';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const filterObj = {
    first_name: "",
    last_name: "",
    gender: "",
    email: "",
    phone: "",
    country: "",
    nationality: "",
    bookingCode: "",
    bookingDate: "",
    agentEmail: "",
};

const CartManagement = (props) => {

    console.log("props", props);
    const [modal_center, setmodal_center] = useState(false);
    const [cartData, setCartData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [value, setValue] = React.useState(10);
    const [sort, setsort] = React.useState("");
    const [sortOrder, setsortOrder] = React.useState("desc");
    const [currentFPage, setCurrentFPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [sizePerPageOrg, setSizePerPage] = useState(5);
    const [image, setImage] = React.useState("");
    const [openLightbox, setOpenLightBox] = React.useState(false);
    const [sizeList, setSizeList] = useState([]);
    const [model, setModel] = useState(false);
    const [buyProductdata, setBuyProductdata] = useState({});


    const handleReset = () => {
        setSearchText('');
        fetchCartData();
    };

    useEffect(() => {
        if (searchText === '') {
            fetchCartData();
        }
    }, [searchText]);


    useEffect(() => {
        fetchCartData();
    }, [currentPage]);

    useEffect(() => {
        fetchCartData();
    }, [sort, sortOrder]);


    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "pagination") {
            if (page != currentPage) {
                setCurrentPage(page);
                console.log("page", page);
            }
        }
        if (type === "search") {
            console.log("searchText", searchText);
        }
    };


    const showLightBox = (image) => {
        setImage(image);
        setOpenLightBox(true);
    };

    const handleDownload = () => {
        const downloadLink = document.createElement("a");
        downloadLink.href = image;
        downloadLink.download = "downloaded-image.jpg";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    function SNoFormatter(cellContent, row, i) {
        return <>{i + 1}</>;
    }

    function ManufacturerFormatter(cellContent, row) {
        return (
            <div className="d-flex gap-2 align-items-start">
                <Link to={`/manufacturers-details/${row?.manufacturerDetail?._id}`}>
                    <div style={{ width: '40px' }}><img src={row?.manufacturerDetail?.logo} width="40px" /></div>
                </Link>
                <div className="flex-product text-start">
                    <Link to={`/manufacturers-details/${row?.manufacturerDetail?._id}`} className="mb-0">{row?.manufacturerDetail?.companyName}</Link>
                    {/* <p className="mb-0">{row?.manufacturerDetail?.mobile}, </p> */}
                    <p className="mb-0">{row?.manufacturerDetail?.address}</p>
                </div>
            </div>
        );
    }

    function ProductFormatter(cellContent, row) {
        return (
            <>
                <img
                    src={row?.productDetail?.images?.[0]}
                    onClick={() => showLightBox(row?.productDetail?.images?.[0])}
                    alt="Not found Image"
                    width={"40px"}
                />
            </>
        );
    }
    function PriceFormatter(cellContent, row) {
        return (
            <>
                <span>From ${row?.price}</span>
            </>
        );
    }


    const selectRow = (item) => {
        setModel(false);
    };


    const columns = [
        {
            text: "S.NO",
            formatter: SNoFormatter,
            sort: false,
        },

        {
            dataField: "images[]",
            text: "Product image",
            sort: false,
            formatter: ProductFormatter,
        },

        {
            dataField: "productDetail.name",
            text: "Product Name",
            sort: false,
        },
        {
            dataField: "quantity",
            text: "Quantity",
            sort: false,
        },
        {
            dataField: "price",
            text: "Price",
            sort: false,
            formatter: PriceFormatter,
        },
        // {
        //     dataField: "stockAlert",
        //     text: "Stock Alert Quantity	",
        //     sort: false,
        // },

    ];

    const handleChange = (event) => {
        setSizePerPage(event.target.value);
        if (currentPage != 1) {
            setCurrentPage(1);
        } else {
            fetchCartData(null, event.target.value);
        }
    };
    const handlesorting = (event) => {
        setsort(event.target.value);
    };
    const handlesortOrder = (event) => {
        setsortOrder(event.target.value);
    };


    function iconFormatter(cellContent, row) {
        return (
            <div className="d-flex gap-2">
                <button type="button" class="btn btn-info" onClick={() => toggleModel(row)}>
                    <i className="fal fa-shopping-cart"></i>&nbsp;
                    Buy Product</button>
            </div>
        );
    }

    const limit = 10;
    const fetchCartData = async (limit = null) => {
        console.log(currentPage);
        setLoader(true);
        const payload = {
            limit: limit ? limit : sizePerPageOrg,
            page: currentPage,
            search: searchText,
            sortOrder: sortOrder,
        };
        try {
            const response = await postRequest(`order/admin/view-cart`, payload);
            const data = response.data;
            setTotalPage(data?.products?.length);
            setCurrentFPage(data?.page);
            setCartData(data || []);
        } catch (error) {
            console.log("Failed to fetch data:", error);
        } finally {
            setLoader(false);
        }
    };


    const toggleModel = (row) => {
        console.log("toggleModel", model);
        setModel(!model);
        const dataFilter = {
            name: row?.productDetail?.name,
            images: row?.productDetail?.images,
            _id: row?.productDetail?._id,
            minimumQuantity: row?.productDetail?.priceRange?.[0]?.minQuantity,
            manufacturerDetail: row?.manufacturerDetail,
        }
        setBuyProductdata(dataFilter);
    };

    const closeModal = () => {
        setModel(false);
    };

    const formatDate = (date) => {
        const optionsDate = { day: '2-digit', month: 'short', year: 'numeric' };
        const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: true };
        // Format the date and time
        const formattedDate = new Date(date).toLocaleDateString('en-GB', optionsDate); // Day Month, Year
        const formattedTime = new Date(date).toLocaleTimeString('en-GB', optionsTime); // HH:mm AM/PM
        // Combine the date and time
        return `${formattedDate} ${formattedTime}`;
    };

    useEffect(() => {
    }, [cartData, kuliesLogo]);

    ///html-image
    const invoiceRef = useRef();
    const [isUploading, setIsUploading] = useState(false);

    const handleScreenshot = () => {
        html2canvas(invoiceRef.current, {
            useCORS: true, // Ensure that images and assets are included
            scrollY: -window.scrollY, // Fix for page scrolling offset issues
            scale: 2, // Increase resolution of the image
        }).then((canvas) => {
            const dataUrl = canvas.toDataURL("image/png");
            const link = document.createElement("a");
            link.href = dataUrl;
            link.download = "invoice-screenshot.png";
            // Wait for the download to be initiated before proceeding
            setTimeout(() => {
                link.click();
            }, 500); // Adjust timeout if necessary
        });
    };



    const handleExportAndSend = async () => {
        if (isUploading) return;
        setIsUploading(true);

        try {
            if (invoiceRef.current) {
                console.log('Converting HTML to image...');

                // Convert the HTML content of invoiceRef to an image using html-to-image
                const imageDataUrl = await htmlToImage.toPng(invoiceRef.current, {
                    filter: (node) => node.tagName !== 'SCRIPT',  // Exclude scripts from being captured
                });

                // Check if the image data is valid
                if (imageDataUrl.startsWith('data:image/png;base64,')) {
                    console.log('Image data is valid, proceeding with PDF creation...');

                    // Display the image preview
                    const previewImage = document.createElement('img');
                    previewImage.src = imageDataUrl;
                    previewImage.alt = 'Preview';
                    previewImage.style.maxWidth = '100%';  // Adjust size for preview
                    previewImage.style.maxHeight = '400px';  // Adjust size for preview

                    // Append the preview image to a container in the DOM (you can customize where to append it)
                    const previewContainer = document.getElementById('imagePreviewContainer');
                    if (previewContainer) {
                        previewContainer.innerHTML = '';  // Clear previous content
                        previewContainer.appendChild(previewImage);
                    }
                } else {
                    throw new Error('Invalid image data');
                }

                // Now create a PDF using jsPDF and add the generated image
                const doc = new jsPDF('p', 'mm', 'a4');  // A4 size page
                doc.addImage(imageDataUrl, 'PNG', 10, 10, 180, 250);  // Adjust positioning and size

                console.log('PDF created successfully. Creating Blob...');

                // Create a Blob from the PDF document (use 'blob' to generate binary data)
                const pdfBlob = doc.output('blob');
                console.log('Blob created:', pdfBlob);

                // Check if the Blob was created successfully
                if (pdfBlob.size === 0) {
                    console.error('Failed to create PDF blob');
                    return;
                }

                // Display the PDF in a new window or iframe
                const pdfUrl = URL.createObjectURL(pdfBlob);  // Create a URL for the PDF Blob
                window.open(pdfUrl, '_blank');  // Open the PDF in a new browser tab

                // Convert the Blob into binary content for upload
                const formData = new FormData();
                formData.append('file', pdfBlob, 'invoice.pdf'); // Only the generated PDF

                console.log('Uploading PDF...');
                try {
                    const response = await postRequestForm('image/doc/upload', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    });
                    console.log('Upload successful:', response.data);
                } catch (uploadError) {
                    console.error('Error uploading PDF:', uploadError);
                }
            }
        } catch (error) {
            console.error('Error exporting or sending PDF:', error);
        } finally {
            setIsUploading(false);
        }
    };

    const history = useHistory();
    ///place order
    const handlePlaceOrder = async (limit = null) => {
        setLoader(true);
        const payload = {
            cartId: cartData?._id,
            // adminPayStatus: 'paid',
            // paymentRefImage: ''
        };
        try {
            const response = await postRequest(`order/admin/cart-check-out`, payload);
            const data = response.data;
            Swal.fire({
                icon: 'success',
                title: 'Order Placed!',
                text: 'Order placed successfully!',
                confirmButtonText: 'OK',
            }).then((result) => {
                if (result.isConfirmed) {
                    history.push('/order-sent-manufacturer');
                }
            });

        } catch (error) {
            console.log("Failed to fetch data:", error);
        } finally {
            setLoader(false);
        }
    };

    const handlerdelete = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this product",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                let body = {
                    cartId: cartData?._id,
                    productId: id,
                };
                postRequest("order/admin/remove-cart-items", body).then((data) => {
                    let Banner = data.status;
                    if (data?.status) {
                        Swal.fire(
                            {
                                icon: 'success',
                                title: 'Deleted!',
                                text: 'Product Deleted successfully',
                                confirmButtonText: 'OK'
                            },);
                        fetchCartData();
                    }
                });
            }
        });
    };


    return (
        <>
            <React.Fragment>
                <ToastContainer />
                <Row>
                    <Col className="10">
                        <div className="page-title-box">
                            <h4>Cart Management</h4>
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item active">User Management</li>:{" "}
                                <li className="breadcrumb-item">Cart Management</li>
                            </ol>
                        </div>
                    </Col>

                </Row>

            </React.Fragment>
            <Card className="cartPage">
                {loader ? (
                    <CardBody style={{ height: "100px" }}>
                        <Spinner
                            color="info"
                            style={{
                                height: "4rem",
                                width: "4rem",
                                position: "absolute",
                                left: "50%",
                            }}
                        >
                            Loading...
                        </Spinner>
                    </CardBody>
                ) : (
                    <>
                        {cartData?.products?.length > 0 ?
                            <div className="card-body p-4">
                                <div className="table-responsive" style={{ maxHeight: '500px' }}>
                                    <table className="mb-3 table table-borderless text-start align-middle mb-0">
                                        <thead>
                                            <tr className="table-active">
                                                <th scope="col" style={{ width: 50 }}>
                                                    #
                                                </th>
                                                <th scope="col">Product Details</th>
                                                <th scope="col">Rate</th>
                                                <th scope="col">Quantity</th>
                                                <th scope="col" className="text-end">
                                                    Amount
                                                </th>
                                                <th scope="col" className="text-end">
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody id="products-list">
                                            {cartData?.products?.map((item, index) => {
                                                return (

                                                    <tr key={index + 1} className="bg-white">
                                                        <th scope="row">{index + 1}</th>
                                                        <td className="text-start" style={{ width: '50%' }}>
                                                            <div className="d-flex align-items-start gap-2">
                                                                <img src={item?.productDetail?.images?.[0]} width={'60px'} />
                                                                <div>
                                                                    <span className="fw-medium">{item?.productDetail?.name}</span>
                                                                    <p className="text-muted mb-0">
                                                                        {item?.productDetail?.description}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td> ${item?.price}</td>
                                                        <td>{item?.quantity}</td>
                                                        <td className="text-end">${item?.totalPrice}</td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                onClick={() => handlerdelete(item?.productId)}>
                                                                <i className="fal fa-trash  fs-5"></i>
                                                            </button>
                                                        </td>
                                                    </tr>

                                                )
                                            })}

                                        </tbody>
                                    </table>
                                    {/*end table*/}
                                </div>
                                <div className="border-top border-top-dashed mt-3">
                                    <table
                                        className="table table-borderless table-nowrap align-middle mb-0 ms-auto"
                                        style={{ width: 350 }}
                                    >
                                        <tbody>
                                            <tr>
                                                <td>Sub Total</td>
                                                <td className="text-end">${cartData?.totalAmount?.toLocaleString()}</td>
                                            </tr>
                                            <tr>
                                                <td>kulies Commission</td>
                                                <td className="text-end">- ${cartData?.kuliesCommission?.toLocaleString()}</td>
                                            </tr>

                                            <tr className="border-top border-top-dashed fs-15">
                                                <th scope="row">Total Amount</th>
                                                <th className="text-end"> ${(cartData?.totalAmount - cartData?.kuliesCommission).toLocaleString()}</th>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {/*end table*/}
                                </div>

                                <div className="hstack gap-2 justify-content-end d-print-none mt-4">
                                    {/* <a href="javascript:window.print()" className="btn btn-success place">
                            <i className="ri-printer-line align-bottom me-1" /> View Invoice
                        </a> */}
                                    <a href="javascript:void(0);" onClick={() => handlePlaceOrder()} className="btn btn-primary place">
                                        <i className="ri-download-2-line align-bottom me-1" />Confirm Order
                                    </a>
                                </div>
                            </div> :
                            <div style={{height : '500px', display : 'flex', alignItems : 'center', justifyContent : 'center'}}>
                              <h3>No items in the cart.</h3>
                            </div>}
                    </>
                )}
            </Card>

            <div className="row cartPage justify-content-center" style={{ display: 'none' }}>
                <div className="col-xxl-9">

                    <div className="card" ref={invoiceRef}>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card-header border-bottom-dashed p-4">
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <img
                                                src={kuliesLogo}
                                                className="card-logo card-logo-dark"
                                                alt="logo dark"
                                                height={57}
                                            />
                                            <div className="mt-sm-5 mt-4">
                                                <h6 className="text-muted text-uppercase fw-semibold">
                                                    Address
                                                </h6>
                                                <p className="text-muted mb-1" id="address-details">
                                                    69 Selous Ave, Harare, Zimbabwe
                                                </p>
                                                <p className="text-muted mb-0" id="zip-code">
                                                    <span>Support:</span> (+263) 24 2795540
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex-shrink-0 mt-sm-0 mt-3">

                                            <h6>
                                                <span className="text-muted fw-normal">Email:</span>
                                                <span id="email">info@kulies.com</span>
                                            </h6>
                                            <h6>
                                                <span className="text-muted fw-normal">Website:</span>{" "}
                                                <a
                                                    href="http://139.59.46.251:3000/"
                                                    className="link-primary"
                                                    target="_blank"
                                                    id="website"
                                                >
                                                    www.kulies.com
                                                </a>
                                            </h6>
                                            <h6 className="mb-0">
                                                <span className="text-muted fw-normal">Contact No: </span>
                                                <span id="contact-no"> (+263) 24 2795540</span>
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                                {/*end card-header*/}
                            </div>
                            {/*end col*/}
                            <div className="col-lg-12">
                                <div className="card-body p-4">
                                    <div className="row g-3">
                                        <div className="col-lg-3 col-6">
                                            <p className="text-muted mb-2 text-uppercase fw-semibold">
                                                Invoice No
                                            </p>
                                            <h5 className="fs-14 mb-0">
                                                #VL<span id="invoice-no">25000355</span>
                                            </h5>
                                        </div>
                                        {/*end col*/}
                                        <div className="col-lg-3 col-6">
                                            <p className="text-muted mb-2 text-uppercase fw-semibold">
                                                Date
                                            </p>
                                            <h5 className="fs-14 mb-0">
                                                <span id="invoice-date">{formatDate(new Date())}</span>{" "}

                                            </h5>
                                        </div>
                                        {/*end col*/}
                                        <div className="col-lg-3 col-6">
                                            <p className="text-muted mb-2 text-uppercase fw-semibold">
                                                Payment Status
                                            </p>
                                            <span
                                                style={{ color: 'green' }}
                                                className="badge bg-success-subtle  fs-11"
                                                id="payment-status"
                                            >
                                                Paid
                                            </span>
                                        </div>
                                        {/*end col*/}
                                        <div className="col-lg-3 col-6">
                                            <p className="text-muted mb-2 text-uppercase fw-semibold">
                                                Total Amount
                                            </p>
                                            <h5 className="fs-14 mb-0">
                                                $<span id="total-amount">
                                                    {(cartData?.totalAmount - cartData?.kuliesCommission).toLocaleString()}
                                                </span>
                                            </h5>
                                        </div>
                                        {/*end col*/}
                                    </div>
                                    {/*end row*/}
                                </div>
                                {/*end card-body*/}
                            </div>
                            {/*end col*/}
                            <div className="col-lg-12">
                                <div className="card-body p-4 border-top border-top-dashed">
                                    <div className="row g-3">
                                        <div className="col-6">
                                            <h6 className="text-muted text-uppercase fw-semibold mb-3">
                                                Billing Address
                                            </h6>
                                            {/* <p className="fw-medium mb-2" id="billing-name">
                                                David Nichols
                                            </p> */}
                                            <p className="text-muted mb-1" id="billing-address-line-1">
                                                69 Selous Ave, Harare, Zimbabwe
                                            </p>
                                            <p className="text-muted mb-1">
                                                <span>Phone: +</span>
                                                <span id="billing-phone-no">(+263) 24 2795540</span>
                                            </p>

                                        </div>
                                        {/*end col*/}
                                        <div className="col-6">
                                            <h6 className="text-muted text-uppercase fw-semibold mb-3">
                                                Shipping Address
                                            </h6>
                                            <p className="fw-medium mb-2" id="shipping-name">
                                                Central Warehouse
                                            </p>
                                            <p className="text-muted mb-1" id="shipping-address-line-1">
                                                123 Industrial Ave, Springfield, IL
                                            </p>
                                            <p className="text-muted mb-1">
                                                <span>Phone: +</span>
                                                <span id="shipping-phone-no">+ (263) 3456789</span>
                                            </p>
                                        </div>
                                        {/*end col*/}
                                    </div>
                                    {/*end row*/}
                                </div>
                                {/*end card-body*/}
                            </div>
                            {/*end col*/}
                            <div className="col-lg-12">
                                <div className="card-body p-4">
                                    <div className="table-responsive">
                                        <table className="table table-borderless text-center  align-middle mb-0">
                                            <thead>
                                                <tr className="table-active">
                                                    <th scope="col" style={{ width: 50 }}>
                                                        #
                                                    </th>
                                                    <th scope="col">Product Details</th>
                                                    <th scope="col">Rate</th>
                                                    <th scope="col">Quantity</th>
                                                    <th scope="col" className="text-end">
                                                        Amount
                                                    </th>
                                                </tr>
                                            </thead>
                                            {/* <tbody id="products-list">
                                                {cartData?.products?.map((item, index) => {
                                                    return (

                                                        <tr key={index + 1} className="bg-white">
                                                            <th scope="row">{index + 1}</th>
                                                            <td className="text-start" style={{ width: '50%' }}>
                                                                <div className="d-flex align-items-start gap-2">
                                                                    <img src={item?.productDetail?.images?.[0]} width={'60px'} />
                                                                    <div>
                                                                        <span className="fw-medium">{item?.productDetail?.name}</span>
                                                                        <p className="text-muted mb-0">
                                                                            {item?.productDetail?.description}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td> ${item?.price}</td>
                                                            <td>{item?.quantity}</td>
                                                            <td className="text-end">${item?.totalPrice}</td>
                                                        </tr>

                                                    )
                                                })}

                                            </tbody> */}
                                        </table>
                                        {/*end table*/}
                                    </div>
                                    <div className="border-top border-top-dashed mt-2">
                                        <table
                                            className="table table-borderless table-nowrap align-middle mb-0 ms-auto"
                                            style={{ width: 250 }}
                                        >
                                            <tbody>
                                                <tr>
                                                    <td>Sub Total</td>
                                                    <td className="text-end">${cartData?.totalAmount?.toLocaleString()}</td>
                                                </tr>
                                                <tr>
                                                    <td>kulies Commission</td>
                                                    <td className="text-end">- ${cartData?.kuliesCommission?.toLocaleString()}</td>
                                                </tr>

                                                <tr className="border-top border-top-dashed fs-15">
                                                    <th scope="row">Total Amount</th>
                                                    <th className="text-end"> ${(cartData?.totalAmount - cartData?.kuliesCommission).toLocaleString() || 0}</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                        {/*end table*/}
                                    </div>

                                    <div className="hstack gap-2 justify-content-end d-print-none mt-4">
                                        <a href="javascript:window.print()" className="btn btn-success">
                                            <i className="ri-printer-line align-bottom me-1" /> Print
                                        </a>
                                        <button
                                            onClick={handleScreenshot}
                                            className="btn btn-info"
                                        >
                                            <i className="ri-camera-line align-bottom me-1" /> Screenshot
                                        </button>
                                        <a href="javascript:void(0);" onClick={() => handleExportAndSend()} className="btn btn-primary">
                                            <i className="ri-download-2-line align-bottom me-1" /> Download
                                        </a>
                                    </div>
                                </div>
                                {/*end card-body*/}
                            </div>
                            {/*end col*/}
                        </div>
                        {/*end row*/}
                    </div>
                    {/*end card*/}
                </div>
                {/*end col*/}
            </div>



        </>
    );
};

export default CartManagement;
